











export default {
  props: ['menu'],
};
